export default __webpack_public_path__ + "static/media/facebook.8a8ec84a.svg";